module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=NF - Norfolk Island.aa2f5e19.svg";